import React from 'react';
import PropTypes from 'prop-types';
import { Select, Stack, useController } from '@metarouter-private/mr-mui';

import { CONSENT_MODES } from 'api/consent-modes/modes';
import OPTIONS from 'app/components/consent-mode-select/ConsentModeSelect/options';
import ConsentModeExternalAlert from 'app/components/consent-mode-select/ConsentModeExternalAlert';

// re-maps to mr-mui Select style options
const SELECT_OPTIONS = OPTIONS.map(({ value, text }) => ({ value, label: text }));

/**
 * Uses useController over FormFieldContext + FormSelect because this needs handle onChange to update
 * sibling consent fields (cannot currently pass onChange to FormSelect).
 */
export default function ConsentModeSelect({ name, defaultValue, onChange }) {
  const { field } = useController({
    name,
    defaultValue,
    rules: { required: true },
  });

  const isExternal = field.value === CONSENT_MODES.external;

  const handleChange = event => {
    const value = event.target.value;
    field.onChange(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Stack spacing={2}>
      <Select
        value={field.value}
        onChange={handleChange}
        options={SELECT_OPTIONS}
        label="Consent Mode"
        variant="outlined"
        size="small"
        required
        data-test-id="consentModeSelect"
      />
      {isExternal && <ConsentModeExternalAlert />}
    </Stack>
  );
}

ConsentModeSelect.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
};

ConsentModeSelect.defaultProps = {
  defaultValue: CONSENT_MODES.ace,
  onChange: null,
};
